// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchResult_wrapper__leyC_"};